export function formatUcfirst (s) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}
